module.exports = __webpack_public_path__ + "static/media/F5D04C5B-3A33-4D14-BEDC-672751F012C8.c16a76eb.jpeg";